// Models
import Model from './Model'

class AccountBalance extends Model {
  get schema () {
    return [
      'currency',
      'balance',
      'realBalance',
      'pending',
      'reserved'
    ]
  }
}

export default AccountBalance
